__webpack_require__.p = "/ui-standalone/referrals-hub/";